import { defineMessages } from 'react-intl'

export default defineMessages({
  add: {
    id: 'Add',
    defaultMessage: 'Add'
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  deleting: {
    id: 'Deleting',
    defaultMessage: 'Deleting...'
  },
  developerGuide: {
    id: 'SpaceCustomAppEditPage.AddAppDescription.AppDeveloperGuide',
    defaultMessage: 'App Developer Guide'
  },
  install: {
    id: 'Install',
    defaultMessage: 'Install'
  },
  appUserInterface: {
    id: 'SpaceAppsPage.AppCatalog.Details.MicroApp',
    defaultMessage: 'User Interface'
  },
  appUserInterfaceDescription: {
    id: 'SpaceAppsPage.AppCatalog.Details.MicroApp.Description',
    defaultMessage:
      'A user interface provides your employees with a visual, interactive way to use the app. They can find the app interface in the Apps section of the Workgrid toolbar.'
  },
  noSettingsInfo: {
    id: 'SpaceAppsPage.AppCatalog.Details.NoSettingsInfo',
    defaultMessage: 'No Settings Information is available for this app'
  },
  overview: {
    id: 'SpaceAppsPage.AppCatalog.Details.Overview',
    defaultMessage: 'Overview'
  },
  saving: {
    id: 'Saving',
    defaultMessage: 'Saving...'
  },
  settingsInfo: {
    id: 'SpaceAppsPage.AppCatalog.Details.SettingsInfo',
    defaultMessage: 'Settings Info'
  },
  functionalityFeaturesSettings: {
    id: 'SpaceAppsPage.AppCatalog.Details.FunctionalityFeaturesSettings',
    defaultMessage: 'App Functionality & Features'
  },
  audienceTargetingSettings: {
    id: 'SpaceAppsPage.AppCatalog.Details.AudienceTargetingSettings',
    defaultMessage: 'Audience Targeting'
  },
  audienceTargetingSettingsDescription: {
    id: 'SpaceAppsPage.AppCatalog.Details.AudienceTargetingSettingsDescription',
    defaultMessage: 'Target user profile attributes to make the app available to the right people.'
  },
  smartNotifications: {
    id: 'SpaceAppsPage.AppCatalog.Details.SmartNotifications',
    defaultMessage: 'Smart Notifications'
  },
  smartNotificationsDescription: {
    id: 'SpaceAppsPage.AppCatalog.Details.SmartNotificationsDescription',
    defaultMessage:
      "Apps can deliver personalized communications to employees' To Know and To Do panels for visibility and value in the right place at the right time. Smart notifications can include approvals, alerts, and task-oriented notifications."
  },
  unableToLoad: {
    id: 'SpaceAppsPage.AppCatalog.Details.ErrorMessage',
    defaultMessage: 'Sorry we were unable to load this app detail at this time. Please try again later!'
  },
  unableToLoadHeader: {
    id: 'SpaceAppsPage.AppCatalog.Details.UnableToLoadHeader',
    defaultMessage: 'Unable to load app details'
  },
  documentationLink: {
    id: 'SpaceAppsPage.AppCatalog.Details.DocumentationLink',
    defaultMessage: 'See Reference Documents'
  },
  categories: {
    id: 'SpaceAppsPage.AppCatalog.Details.Categories',
    defaultMessage: 'Categories'
  },
  features: {
    id: 'SpaceAppsPage.AppCatalog.Details.Features',
    defaultMessage: 'Features'
  },
  integrations: {
    id: 'SpaceAppsPage.AppCatalog.Details.Integrations',
    defaultMessage: 'Integrations'
  }
})
